import { render, staticRenderFns } from "./fee-lab-evolucao-patrimonio.vue?vue&type=template&id=7dc3367d&scoped=true&"
import script from "./fee-lab-evolucao-patrimonio.vue?vue&type=script&lang=js&"
export * from "./fee-lab-evolucao-patrimonio.vue?vue&type=script&lang=js&"
import style0 from "./fee-lab-evolucao-patrimonio.vue?vue&type=style&index=0&id=7dc3367d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc3367d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dc3367d')) {
      api.createRecord('7dc3367d', component.options)
    } else {
      api.reload('7dc3367d', component.options)
    }
    module.hot.accept("./fee-lab-evolucao-patrimonio.vue?vue&type=template&id=7dc3367d&scoped=true&", function () {
      api.rerender('7dc3367d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fee-fixo/components/fee-lab-evolucao-patrimonio/fee-lab-evolucao-patrimonio.vue"
export default component.exports